import { Contact } from "../_types/internalContacts.types";

export const ORGANIZATION_CONTACT_ROLES = ["business", "other", "virtualReceptionist", "admin", "accountManager", "superadmin"];

export const getContactId = (contact: Contact): string => {
  // For company type, id might be a number
  if (contact.type === "company" && contact.id) {
    return contact.id;
  }
  // For other types, use uid
  return contact.uid;
};

export const getContactTitle = (contact: Contact): string => {
  if (contact.businessName) return contact.businessName;

  const alias = contact.alias?.trim();
  const displayName = contact.displayName?.trim();
  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(" ");

  if (contact.useAliasAsDisplayName && alias) return alias;

  return displayName || fullName || contact.name || alias || "";
};

export const getContactSubtitle = (contact: Contact): string => {
  if (contact.type === "company") {
    const companyDetails = [contact.businessPhone, contact.email].filter(Boolean);
    return companyDetails.join(" · ") || "Organization";
  }

  const parts = [contact.companyName, contact.email || contact.businessPhone].filter(Boolean);

  return parts.join(" · ");
};

/** Person name for internal WebRTC peers (avoids company businessName as display). */
export const getInternalPeerDisplayName = (contact: Contact): string => {
  if (contact.type === "organizationCoworker" || contact.type === "workforce") {
    const alias = contact.alias?.trim();
    if (contact.useAliasAsDisplayName && alias) return alias;

    const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(" ");
    if (fullName) return fullName;
    if (contact.name) return contact.name;
  }

  return getContactTitle(contact);
};

export const resolveInternalPeerDisplayName = (peerUid: string | undefined, contacts: Contact[], fallbackName?: string | null): string => {
  const fallback = fallbackName?.trim();
  if (!peerUid) return fallback || "Internal caller";

  const normalizedPeer = peerUid.toLowerCase();
  const match = contacts.find((contact) => {
    const candidates = [contact.userUid, contact.uid].filter(Boolean) as string[];
    return candidates.some((id) => id.toLowerCase() === normalizedPeer);
  });

  if (match) {
    const title = getInternalPeerDisplayName(match);
    if (title) return title;
  }

  return fallback || "Internal caller";
};
